import {
  fetchModuleStatesPending,
  fetchModuleStatesSuccess,
  fetchModuleStatesError,
} from "../redux/actions/ModuleStateActions";
import SuiteApi from "../api/SuiteApi";
import { Dispatch } from "redux";

export function fetchModuleStates() {
  return (dispatch: Dispatch) => {
    dispatch(fetchModuleStatesPending());
    SuiteApi.getStates()
      .then((moduleStates) => {
        dispatch(fetchModuleStatesSuccess(moduleStates));
      })
      .catch((error) => {
        console.log("error fetching module states", { error });
        dispatch(fetchModuleStatesError(error));
      });
  };
}
